module.exports = __webpack_public_path__ + "media/images/img03-3a4c2f4349ca647e169f10eb3b3113df.png";